import { FooterDisclaimer } from './footerDisclaimer/FooterDisclaimer';
import { FooterNavigation } from './footerNavigation';
import { FooterPaymentsLogoList } from './footerPaymentsLogoList';
import { FooterProps } from '.';
import { FooterWarning } from 'components/footerWarning';
import { Img } from '../../utility/types';
import { SwitchTheme } from './switchTheme';
import { memo } from 'react';
import styles from './Footer.module.scss';

export type disclaimerLogoSection = {
  id: string;
  title: string;
  logoList: Img[];
};

export const Footer = memo(function Footer({
  settingsTitle,
  settingsLabelTema,
  switchTheme,
  footerNavigation,
  paymentLogoList,
  disclaimerParagraph,
  warningLogo,
  warningText,
  certificationsBlock,
}: FooterProps) {
  return (
    <footer suppressHydrationWarning className={styles.footer} data-testid={process.env.NEXT_PUBLIC_CACHE_VERSION}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.leftTopContainer} />
          <div className={styles.leftBottomContainer} />
          <section className={styles.settingsContainer}>
            <h4 className={styles.titleSection}>{settingsTitle}</h4>
            <h5 className={styles.subTitleSection}>{settingsLabelTema}</h5>
            <SwitchTheme labelLight={switchTheme.labelLight} labelDark={switchTheme.labelDark} />
          </section>
          <FooterNavigation navigation={footerNavigation} />
          <FooterPaymentsLogoList paymentLogoList={paymentLogoList} />
          <div className={styles.rightTopContainer} />
          <div className={styles.rightBottomContainer} />
          <FooterWarning warningLogo={warningLogo} warningText={warningText} />
        </div>
      </div>
      <FooterDisclaimer disclaimerParagraph={disclaimerParagraph} certificationsBlock={certificationsBlock} />
    </footer>
  );
});
